// Module
var code = `<div class="wistia_responsive_padding" style="padding:75% 0 0 0;position:relative;" ng-if="\$ctrl.ratio == '4:3'">
  <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
    <div class="wistia_embed wistia_async_{{\$ctrl.video}} {{\$ctrl.playlistEnabled}} seo=false videoFoam=true autoPlay={{\$ctrl.autoplayEnabled}}" style="height:100%;position:relative;width:100%">
      <div class="wistia_swatch" style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;">
        <img ng-src="https://fast.wistia.com/embed/medias/{{\$ctrl.video}}/swatch" style="filter:blur(5px);height:100%;object-fit:contain;width:100%;" alt="" onload="this.parentNode.style.opacity=1;"/>
      </div>
    </div>
  </div>
</div>
<div class="ratio ratio-16x9" id="{{\$ctrl.videoIdPrefix}}vimeo" data-vimeo-id="{{\$ctrl.video}}" data-vimeo-width="100" data-vimeo-height="100" ng-if="\$ctrl.ratio != '4:3'">
  <div id="{{\$ctrl.componentVideoId}}" class="wistia_embed wistia_async_{{\$ctrl.video}} {{\$ctrl.playlistEnabled}} seo=false videoFoam=true autoPlay={{\$ctrl.autoplayEnabled}}" style="height:100%;width:100%">&nbsp;</div>
</div>`;
// Exports
export default code;